export const environment = {
  production: true,
  apiHost: 'http://api-alicante.gesdencolegiosone.es/api/'
};
